import * as z from "zod/v4";
import { zPermissionKey } from "../features/permissions/permissions";
import { zTag } from "./tag";

export const zCompetence = z.object({
  id: z.number(),
  name: z.string().min(3).meta({ title: "Namn" }),
  upgradeId: z.number().optional().nullish(),
  permissions: z.array(zPermissionKey),
  tags: z.array(zTag).optional(),
  needExam: z.boolean().optional().nullish(),
});

export type Competence = z.infer<typeof zCompetence>;
